import React, { Component } from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
// import styled from 'styled-components';

// Pages/Components
import NoMatch from './pages/NoMatch';
import { MainPageContainer } from './pages/Main';
import { NavAccordion } from './components/NavAccordion'
import FJSDetails from './components/projects/FJSDetails';
import SignUp from './components/auth/SignUp';
import SignIn from './components/auth/SignIn';
import CreateFJS from './components/projects/CreateFJS'
import Navbar from './components/NavAccordion/Navbar';

import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

class App extends Component {

  render() {
    return (
      <Router>
        <div className='bg-soft-black'>
          <div className='mx-4'>
            <Row>
              <Navbar />
            </Row>
          </div>
        </div>
        <div className='bg-darkest-gray'>
          <Row>
            <Col sm={3}>
              <NavAccordion />
            </Col>
            <Col sm={9} className='bg-darkest-gray h-screen'>
              
              <Switch>
                <Route exact path='/' component={MainPageContainer} />
                <Route path='/fjstory/:id'component={FJSDetails} /> 
                <Route path='/signin' component={SignIn} />
                <Route path='/signup' component={SignUp} />
                <Route path='/createFJS' component={CreateFJS} />
                <Route component={NoMatch} />
              </Switch>
              
            </Col>
          </Row>
        </div>
      </Router>
    )
  }

};

export default App;